import styles from '../ActivityDropDown.module.scss'

export default function ActivityCheckbox({
  title,
  value,
  isChecked,
  setChecked,
  changeHandler,
}) {
  const onChange = (e) => {
    const { value, checked } = e.target
    if(typeof changeHandler === 'function') {
      changeHandler(checked)
    }
    if(typeof setChecked === 'function') {
      setChecked(title, value, checked)
    }
  }

  return (
    <label className={styles.checkboxWrap}>
      <input
        type='checkbox'
        className={styles.inputCheckbox}
        value={`${value}`}
        onChange={onChange}
        checked={isChecked}
      />
      <span className={styles.checkMark} />
      <p className={styles.title}>{title}</p>
    </label>
  )
}
